<template>
  <b-container fluid class="pb-4">
     <!-- 工程内在庫 -->
    <h1 class="fc-h1">{{this.$i18n.t('stock.title')}}</h1>
    <form>
      <div class="w-100 mb-3">
        <b-card>
          <form>
            <!-- 日時 -->
            <b-form-group
              id="select_date"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('stock.label_date')"
              label-for="input-horizontal"
            >
              <div class="d-flex align-items-center">
                <div class="flex-fill">
                  <b-form-input id="from" v-model="from" type="date"></b-form-input>
                </div>
                <div class="flex-fill">
                  <b-form-input id="fromTime" v-model="fromTime" type="time"></b-form-input>
                </div>
                <div class="flex-shrink-1 px-2">-</div>
                <div class="flex-fill">
                  <b-form-input id="to" v-model="to" type="date"></b-form-input>
                </div>
                <div class="flex-fill">
                  <b-form-input id="toTime" v-model="toTime" type="time"></b-form-input>
                </div>
              </div>
            </b-form-group>
            <!-- 型番 -->
            <b-form-group
              id="code"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('stock.label_code')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="selected" :options="codes" class="mb-3"></b-form-select>
            </b-form-group>
            <div>
              <!-- 検索 -->
              <b-button variant="primary" @click="search" class="float-right px-5">{{this.$i18n.t('stock.button_search')}}</b-button>
            </div>
          </form>
        </b-card>
      </div>
    </form>
    <div v-if="isSearch">
      <div class="row" style="margin-left:0px;">
        <b-card class="col-5">
          <!-- ライン内在庫 -->
          <h2
            :class="showCollapse ? 'collapsed' : null"
            :aria-expanded="showCollapse ? 'true' : 'false'"
            aria-controls="collapse-12"
            @click="showCollapse = !showCollapse"
          >{{this.$i18n.t('stock.label_line_stock')}}</h2>
          <b-collapse id="collapse-12" v-model="showCollapse" class="mt-3">
            <b-table
              :striped="striped"
              :bordered="bordered"
              :borderless="borderless"
              :outlined="outlined"
              :current-page="lineCurrentPage"
              :per-page="linePerPage"
              :small="small"
              :hover="hover"
              :dark="dark"
              :fixed="fixed"
              :foot-clone="footClone"
              :no-border-collapse="noCollapse"
              :items="items"
              :fields="fields"
              :head-variant="headVariant"
              :table-variant="tableVariant"
              class="w-100"
            >
              <template v-slot:cell(num)="row">
                <u>
                  <b-link @click="line(row.item, row.index)">{{ row.item.num }}</b-link>
                </u>
              </template>
            </b-table>
          </b-collapse>
        </b-card>
        <div class="col-7">
          <div v-if="isDispLine">
            <b-card class="col-12">
              <!-- 工程内在庫 -->
            <h2
              :class="showCollapse ? 'collapsed' : null"
              :aria-expanded="showCollapse ? 'true' : 'false'"
              aria-controls="collapse-12"
              @click="showCollapse = !showCollapse"
            >{{this.$i18n.t('stock.label_process_stock')}}</h2>
            <b-collapse id="collapse-12" v-model="showCollapse" class="mt-3">
              <b-pagination
                v-model="procCurrentPage"
                :total-rows="procTotalRows"
                :per-page="procPerPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
              <b-table
                :striped="striped"
                :bordered="bordered"
                :borderless="borderless"
                :outlined="outlined"
                :current-page="procCurrentPage"
                :per-page="procPerPage"
                :small="small"
                :hover="hover"
                :dark="dark"
                :fixed="fixed"
                :foot-clone="footClone"
                :no-border-collapse="noCollapse"
                :items="procItems"
                :fields="procFields"
                :head-variant="headVariant"
                :table-variant="tableVariant"
                class="w-100"
              >
                <template v-slot:cell(num)="row">
                  <u>
                    <b-link
                      @click="serialSearch(row.item, row.index)"
                      :class="showCollapse ? 'collapsed' : null"
                      :aria-expanded="showCollapse ? 'true' : 'false'"
                      aria-controls="collapse-12"
                    >{{ row.item.num  }}</b-link>
                  </u>
                </template>
              </b-table>
            </b-collapse>
            </b-card>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isSerial" class="mt-3">
      <div>
        <!-- シリアル一覧 -->
        <b-card :title="this.$i18n.t('stock.label_serial_list')">
        <b-row>
            <b-col sm="5" md="1" class="my-1">
              <b-form-select
                v-model="serialPerPage"
                id="perPageSelect"
                size="sm"
                :options="pageOptions"
              ></b-form-select>
            </b-col>
            <b-col sm="7" md="11" class="my-1">
              <b-pagination
                v-model="serialCurrentPage"
                :total-rows="serialTotalRows"
                :per-page="serialPerPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
        </b-row>
          <b-table
            :striped="striped"
            :bordered="bordered"
            :borderless="borderless"
            :outlined="outlined"
            :current-page="serialCurrentPage"
            :small="small"
            :hover="hover"
            :dark="dark"
            :fixed="fixed"
            :foot-clone="footClone"
            :no-border-collapse="noCollapse"
            :items="serialItems"
            :fields="serialFields"
            :head-variant="headVariant"
            :table-variant="tableVariant"
            :per-page="serialPerPage"
          >
            <template v-slot:cell(serial)="row">
              <u>
                <b-link @click="calteFromOtherPage(row.item.serial)">{{ row.item.serial }}</b-link>
              </u>
            </template>
          </b-table>
          <div>
            <!-- CSV出力 -->
            <b-button variant="primary" @click="csv" class="float-right">{{this.$i18n.t('stock.button_csv')}}</b-button>
          </div>
        </b-card>
      </div>
    </div>
    <!-- エラーメッセージ用 -->
    <confirm-modal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  data () {
    return {
      pageOptions: [10, 20, 50, 100],
      serialPerPage: 10,
      serialTotalRows: 1,
      serialCurrentPage: 1,
      selected: null,
      qtyFrom: null,
      qtyTo: null,
      note: null,
      lineCurrentPage: 1,
      linePerPage: 5,
      lineTotalRows: 1,
      procCurrentPage: 1,
      procPerPage: 5,
      procTotalRows: 1,
      codes: [
        { value: null, text: this.$i18n.t('stock.label_all_code') }
      ],
      fields: [
        { key: 'line', label: this.$i18n.t('stock.label_line'), sortable: true },
        { key: 'num', label: this.$i18n.t('stock.label_stock'), sortable: true }
      ],
      procFields: [
        { key: 'process', label: this.$i18n.t('stock.label_process'), sortable: true },
        { key: 'num', label: this.$i18n.t('stock.label_stock'), sortable: true }
      ],
      serialFields: [
        { key: 'serial', label: this.$i18n.t('stock.label_serial'), sortable: true },
        { key: 'code', label: this.$i18n.t('stock.label_code'), sortable: true },
        { key: 'date', label: this.$i18n.t('stock.label_process_date'), sortable: true }
      ],
      items: [],
      procItems: [],
      serialItems: [],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      showCollapse: true,
      noCollapse: true,
      isSearch: false,
      isDispLine: false,
      isSerial: false,
      from: '',
      to: '',
      fromTime: '',
      defFromTime: '',
      toTime: '',
      defToTime: '',
      startForSearched: null,
      endForSearched: null,
      codeForSearched: null,
      revForSearched: null,
      errMsg: null,
      errSbj: null
    }
  },
  async created () {
    var dates = await this.getDates()
    this.from = window.formatDate(dates.start, 'yyyy-MM-dd')
    this.to = window.formatDate(dates.end, 'yyyy-MM-dd')
    this.fromTime = window.formatDate(dates.start, 'HH:mm')
    this.defFromTime = this.fromTime
    this.toTime = window.formatDate(dates.end, 'HH:mm')
    this.defToTime = this.toTime

    var headers = {
      'Content-Type': 'application/json',
      'opId': this.$store.store.state.opId,
      'ticketId': this.$store.store.state.ticketId
    }

    var body = {}
    body.code = ''
    body.codeLikeFlg = ''
    body.rev = ''
    body.revLikeFlg = ''
    body.petname = ''
    body.efFlg = ''

    // 型番取得
    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    this.$axios
      .post(window.END_POINT + '/master/productinfo/select', body, {
        'headers': headers
      })
      .then(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-err')
          }
        } else {
          var productInfoList = res.data.productInfo
          var codes = []

          // 整形
          for (var i = 0; i < productInfoList.length; i++) {
            var code = {}
            code.value = productInfoList[i].code + ',' + productInfoList[i].rev
            code.text = productInfoList[i].code + ' - ' + productInfoList[i].rev + ' - ' + productInfoList[i].petname
            codes.push(code)
          }
          // 一旦データクリア
          this.codes.splice(1)
          // データセット
          this.codes.splice(1, 0, ...codes)
        }
      })
      .catch(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('common.unexpected_error')
        this.$bvModal.show('md-err')
        console.log(res)
      })
  },
  mounted () {
    // Set the initial number of items
    this.lineTotalRows = this.items.length
    this.procTotalRows = this.procItems.length
  },
  methods: {
    // 検索アクション
    search: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      // 日付
      if (this.from === '' && this.to === '') {
        this.errSbj = this.$i18n.t('stock.title')
        this.errMsg = this.$i18n.t('stock.err_day_hissu')
        this.$bvModal.show('md-err')
        return
      }
      var startDate = ''
      if (this.from !== '') {
        var from = ''
        if (this.fromTime !== '') {
          from = this.$moment(this.from + ' ' + this.fromTime, 'YYYY-MM-DD HH:mm:00')
        } else {
          from = this.$moment(this.from + ' ' + this.defFromTime, 'YYYY-MM-DD HH:mm:00')
        }
        startDate = from.utc().format('YYYY-MM-DD HH:mm:ss')
        body.start = startDate
      }
      // ライン内在庫数取得用に入力された日時を保持しておく
      this.startForSearched = startDate

      var endDate = ''
      if (this.to !== '') {
        var to = ''
        if (this.toTime !== '') {
          to = this.$moment(this.to + ' ' + this.toTime, 'YYYY-MM-DD HH:mm:00')
        } else {
          to = this.$moment(this.to + ' ' + this.defToTime, 'YYYY-MM-DD HH:mm:00')
        }
        endDate = to.utc().format('YYYY-MM-DD HH:mm:ss')
        body.end = endDate
      }

      // 日付論理チェック
      var cmpFrom = new Date(startDate)
      var cmpTo = new Date(endDate)
      if (cmpFrom.getTime() > cmpTo.getTime()) {
        this.errSbj = this.$i18n.t('stock.title')
        this.errMsg = this.$i18n.t('stock.err_from_to_reverse')
        this.$bvModal.show('md-err')
        return
      }

      var selected = []
      selected[0] = null
      selected[1] = null
      if (this.selected !== null) {
        selected = this.selected.split(',')
      }
      body.code = selected[0]
      body.rev = selected[1]
      // ライン内在庫数取得用に入力された日時を保持しておく
      this.endForSearched = endDate
      this.codeForSearched = selected[0]
      this.revForSearched = selected[1]

      // ライン内在庫取得
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/stock/inLineStock', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var stockInfoList = res.data.stockInfo
            var items = []
            if (stockInfoList.length === 0) {
              this.isSearch = false
              this.isDispLine = false
              this.isSerial = false
              this.showCollapse = false
              this.errSbj = this.$i18n.t('stock.title')
              this.errMsg = this.$i18n.t('stock.err_not_serial')
              this.$bvModal.show('md-err')
              return
            }

            // 整形
            for (var i = 0; i < stockInfoList.length; i++) {
              var item = {}
              item.lineId = stockInfoList[i].lineId
              item.line = stockInfoList[i].lineName
              item.num = stockInfoList[i].count
              items.push(item)
            }
            // 一旦データクリア
            this.items.splice(0)
            // データセット
            this.items.splice(0, 0, ...items)
            // ページング設定
            this.lineTotalRows = this.items.length

            this.isSearch = true
            this.isDispLine = false
            this.isSerial = false
            this.showCollapse = true
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
          console.log(res)
        })
    },
    // ライン内在庫数リンククリックアクション
    line: function (item, index) {
      this.isDispLine = true
      this.isSerial = false
      this.showCollapse = true

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.start = this.startForSearched
      body.end = this.endForSearched
      body.code = this.codeForSearched
      body.rev = this.revForSearched
      body.line = item.lineId

      // 工程内在庫取得
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/stock/inProcessStock', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var stockInfoList = res.data.stockInfo
            var procItems = []

            // 整形
            for (var i = 0; i < stockInfoList.length; i++) {
              var procItem = {}
              procItem.processId = stockInfoList[i].processId
              procItem.process = stockInfoList[i].processName
              procItem.num = stockInfoList[i].count
              procItem.lineId = item.lineId
              procItems.push(procItem)
            }
            // 一旦データクリア
            this.procItems.splice(0)
            // データセット
            this.procItems.splice(0, 0, ...procItems)
            // ページング設定
            this.procTotalRows = this.procItems.length
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
          console.log(res)
        })
    },
    // 工程内在庫数リンククリックアクション
    serialSearch: function (item, index) {
      this.isSerial = true
      this.showCollapse = false

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.start = this.startForSearched
      body.end = this.endForSearched
      body.code = this.codeForSearched
      body.rev = this.revForSearched
      body.line = item.lineId
      body.process = item.processId

      // 在庫シリアル一覧取得
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/stock/stockSerial', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var serialInfoList = res.data.serialInfo
            var serialItems = []

            // 整形
            for (var i = 0; i < serialInfoList.length; i++) {
              var serialItem = {}
              serialItem.serial = serialInfoList[i].serial
              serialItem.code = serialInfoList[i].code + ' - ' + serialInfoList[i].rev + ' - ' + serialInfoList[i].petname
              // utc -> local 変換
              // momentオブジェクト(UTC)に変換
              var utc = this.$moment.utc(serialInfoList[i].passDate, 'YYYY-MM-DD HH:mm:ss')
              if (String(utc) === 'Invalid date') {
                serialItem.date = ''
              } else {
                // local時刻に変換＆フォーマット
                serialItem.date = utc.local().format('YYYY-MM-DD HH:mm:ss')
              }
              serialItems.push(serialItem)
            }
            // ページング設定
            this.serialTotalRows = serialItems.length
            // 一旦データクリア
            this.serialItems.splice(0)
            // データセット
            this.serialItems.splice(0, 0, ...serialItems)
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
          console.log(res)
        })
    },
    // CSV出力
    csv: function () {
      // タイトル設定
      var title = []
      this.serialFields.forEach(el => {
        title.push('"' + el['label'] + '"')
      })
      var csv = title.join(',')
      csv += '\r\n'
      // データ設定
      var data = []
      this.serialItems.forEach(el => {
        data = []
        data.push('"' + el['serial'] + '"')
        data.push('"' + el['code'] + '"')
        data.push('"' + el['date'] + '"')
        csv += data.join(',')
        csv += '\r\n'
      })
      // CSVダウンロード
      window.downloadCsv(csv, 'StockSerial')
    },
    getDates: async function () {
      var startTime = ''
      var dates = []
      // 開始時間取得
      var reqObj = {}
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      await this.$axios
        .post(window.END_POINT + '/common/selectStartTime', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            startTime = res.data.shift_start_time
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
          console.log(res)
        })

      // 日またぎ確認、時間取得
      var nowTime = window.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')
      dates = window.getStartTime(startTime, nowTime, false)

      return dates
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    },
    calteFromOtherPage: function (serial) {
      var path = '/calte'
      this.$router.push({ path: path, query: {serial: [serial]} })
    }
  }
}
</script>

<style scoped>
.fc-triangle-r {
  content: "";
  border-left: 1rem solid rgba(255, 255, 255, 0.5);
  border-top: 1rem solid transparent;
  border-bottom: 1rem solid transparent;
  position: absolute;
  top: 1rem;
  left: -0.5rem;
  width: 0;
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Stock.vue